import script from "./verifikasiDataKontraktorPenerbitanPage.vue?vue&type=script&setup=true&lang=js"
export * from "./verifikasiDataKontraktorPenerbitanPage.vue?vue&type=script&setup=true&lang=js"

import "./verifikasiDataKontraktorPenerbitanPage.vue?vue&type=style&index=0&id=e07b27e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e07b27e0"]])

export default __exports__